/**
 * Transaction-type predicates.
 *
 * The Fees flow serves both Purchase and Refinance from the same route, page and
 * form (routes.js only defines `forms/fees`); the discriminator is the
 * `transactionType` string on the transaction info / saved fees form data.
 *
 * Prefer this over the `TransactionID.includes("REF")` check in
 * pages/feeOutput/index.js: VIN characters include R, E and F, so a VIN
 * containing the literal substring "REF" false-positives on that test.
 */

export const REFINANCE = 'Refinance';

/**
 * True when the supplied transaction info / fees form data represents a
 * refinance rather than a purchase.
 *
 * Accepts the whole object rather than the bare string so callers can pass
 * whichever slice they already have to hand (`transactionInfo` in the form,
 * `feesFormData` on the output surfaces) without unwrapping it first.
 */
export const isRefinance = (data) => data?.transactionType === REFINANCE;

/**
 * Trade-in and rebate inputs do not apply to a refinance: there is no vehicle
 * being traded and no manufacturer incentive on a refi. The refi backend drops
 * them anyway -- ATC_Flask/refi_fees.py builds its `inputs` from a fixed
 * allow-list that never references TradeIn* or Rebate -- so showing them
 * invited users to enter figures that silently did nothing.
 *
 * Hidden on the form, the output page and the PDF, and stripped from the
 * request payload, whenever isRefinance() is true.
 */
export const PURCHASE_ONLY_FIELDS = [
  'TradeInYear',
  'TradeInValue',
  'ManufacturerRebate',
];
